import React, { useState, useCallback } from "react";
import Dustbin from "../components/DustbinListenMatch";
import Box from "../components/BoxListenMatch";
import update from "immutability-helper";
import LessonInstruction from "../containers/instruction/LessonInstruction";
import { useRegisterProgress } from "../hooks/useRegisterProgress";

const Container = props => {
  const data = props.blockData.content;
  const { blockData, contentIndex, lessonId, totalIndexes, audioUrl } = props
  let [solve, setSolve] = useState(false)

  // hook useRegisterProgress
  const { registerProgress } = useRegisterProgress(
    blockData.block_id,
    lessonId,
    blockData.sectionId,
    blockData.section,
    blockData.num,
    totalIndexes,
    "listen_and_match"
  );

  const handleCompleteClick = async () => {
    try {
      await registerProgress();
    } catch (error) {
      console.log("Erro ao registrar progresso: ", error);
    }
  };

  let getTranslation = data.filter(function (arr, index) {
    if (arr.type === "translation") {
      arr.lastDroppedItem = null;
      arr.answer = (data[index + 1] && data[index + 1].en) || "";      
      return arr;
    }
  });

  let filTranslation = getTranslation.filter(function (el) {
    return el !== null;
  });

  let getDrill = data.filter(function (arr) {
    if (arr.type === "drill") {
      arr.lastDroppedItem = null;
      return arr;
    }
  });

  function shuffle(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  }
  let filDrill = getDrill.filter(function (el) {
    return el != null;
  });

  const [dustbins, setDustbins] = useState(shuffle(filTranslation));
  const [boxes] = useState(filDrill);

  const [droppedBoxNames, setDroppedBoxNames] = useState([]);
  function isDropped(boxName) {
    return droppedBoxNames.indexOf(boxName) > -1;
  }
  const handleDrop = useCallback(
    (index, item) => {
      const { name } = item;
      setDroppedBoxNames(
        update(droppedBoxNames, name ? { $push: [name] } : { $push: [] })
      );
      setDustbins(
        update(dustbins, {
          [index]: {
            lastDroppedItem: {
              $set: item
            }
          }
        })
      );
    },
    [droppedBoxNames, dustbins]
  );

  // sets background to white color
  const bgColor = blockData.content[contentIndex].type === "instruction" ? "new-bg-color" : "";
  const containerClasses = `default-card container ${bgColor}`;

  return (
    <div className={containerClasses} style={{ width: '100%' }}>
      {blockData.content[contentIndex].type === "instruction" ? (
        <>
          <LessonInstruction
            instructionText={blockData.content[contentIndex].instruction}
            audioUrl={audioUrl}
          />
        </>
      ) : (
        <div>
          <div
            style={{ overflow: "hidden", clear: "both", justifyContent: 'center' }}
            className="row"
          >
            {dustbins.map(({ en, picture, lastDroppedItem, answer }, index) => (
                <Dustbin
                  accepts={answer} // Quando o accepts é igual ao type do component Box, eles se conectam
                  lastDroppedItem={lastDroppedItem}
                  getPicture={picture}
                  name={en.substr(en.length - 1)}
                  onDrop={item => handleDrop(index, item)}
                  key={index}
                  solve={solve}
                />
            ))}
          </div>

          <div
            style={{
              overflow: "hidden",
              clear: "both",
              bottom: "67px",
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            {boxes.map(({ en }, index) => (
              // Quando o type é igual ao accepts do component Dustbin, eles se conectam
              <Box name={en} type={en} isDropped={isDropped(en)} key={index} />
            ))}
          </div>
          <button onClick={() => {
            if (solve) {
              props.step('skipForward')
              handleCompleteClick()
            } else {
              setSolve(true)
            }
          }} className="listen-drag-check-maze">
            {
              solve
                ? 'Done'
                : 'Solve'
            }
          </button>
        </div>
      )}
    </div>
  );
};
export default Container;